import { useEffect } from "react";

import { useProjectName } from "./useProjectName";
import { useSelectFeaturesStatisticsActive } from "../selectFeatures/useSelectFeaturesStatisticsActive";
import { useSelectFeaturesLayerName } from "../selectFeatures/useSelectFeaturesLayerName";
import { useFeatureCard } from "../../modules/FeatureCard/hooks/useFeatureCard";

export const useOnProjectChange = () => {
  const projectName = useProjectName();
  const [selectFeaturesStatisticsActive, setSelectFeaturesStatisticsActive] = useSelectFeaturesStatisticsActive();
  const [selectFeaturesLayerName, setSelectFeaturesLayerName] = useSelectFeaturesLayerName();
  const [, { closeCard }] = useFeatureCard();

  useEffect(() => {
    if (selectFeaturesStatisticsActive) {
      setSelectFeaturesStatisticsActive(false);
    }

    if (selectFeaturesLayerName) {
      setSelectFeaturesLayerName(undefined);
    }

    closeCard();
  }, [projectName]); // eslint-disable-line
};
